import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';

export default class JobFullDetailsJobNotificationsDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
          data: props.data || null
        }
    }
    componentWillReceiveProps(nextProps) {
      this.setState({
        data: nextProps.data,
      });
      
    }
    handleDiffHistory(e) {
        let infoModal = $('#infomodal');
        document.querySelector('#infomodallabel').innerHTML = 'History';
        let details = this.state.data;
        details = JSON.parse(details);
        
        let tbl = '';
        let Joboutput = "";
        let Vehicleoutput = "";
        let output = "";
        let pickupAddressoutput = "";
        let dropoffAddressoutput = "";

        if(details.job){
          Joboutput =  Object.keys(details.job.old).map((jkey)=> {
                let keyPart = jkey.replace(/_/g, ' ').toLowerCase();
                let keyArrayGroup = ['scheduled_dropoff_day','scheduled_pickup_day','scheduled_dropoff_month','scheduled_pickup_month'];
                let oldVal = details.job.old[jkey];
                let newVal = details.job.new[jkey];
                if(oldVal == 1 && keyArrayGroup.indexOf(jkey) == -1){
                  oldVal = 'Yes';
                }else if(oldVal == 0 && keyArrayGroup.indexOf(jkey) == -1){
                  oldVal = 'No';
                }
                if(newVal == 1 && keyArrayGroup.indexOf(jkey) == -1){
                  newVal = 'Yes';
                }else if(newVal == 0 && keyArrayGroup.indexOf(jkey) == -1){
                  newVal = 'No';
                }
                let html = "<tr><td><b>"+keyPart+"</b></td><td>"+oldVal+"</td><td>"+newVal+"</td></tr>";
                return html;
            });
        }
        if(details.vehicle){
          Vehicleoutput = "<td colspan='3' class='text-center'>Vehicle Details</td>";
          Vehicleoutput +=  Object.keys(details.vehicle.old).map((vkey)=> {
              let keyPart = vkey.replace(/_/g, ' ').toLowerCase();
              let oldVal = details.vehicle.old[vkey];
              let newVal = details.vehicle.new[vkey];
              let html = "<tr><td><b>"+keyPart+"</b></td><td>"+oldVal+"</td><td>"+newVal+"</td></tr>";
              return html;
          });
        }
        if(details.pickup_address){
          pickupAddressoutput = "<td colspan='3' class='text-center'>Pickup Address</td>";
          pickupAddressoutput +=  Object.keys(details.pickup_address.old).map((pkey)=> {
              let keyPart = pkey.replace(/_/g, ' ').toLowerCase();
              let oldVal = details.pickup_address.old[pkey];
              let newVal = details.pickup_address.new[pkey];
              if(oldVal == null){
                oldVal = "";
              }
              if(newVal == null){
                newVal = "";
              }
              let html = "<tr><td><b>"+keyPart+"</b></td><td>"+oldVal+"</td><td>"+newVal+"</td></tr>";
              return html;
          });
        }
        if(details.dropoff_address){
          dropoffAddressoutput = "<td colspan='3' class='text-center'>Dropoff Address</td>";
          dropoffAddressoutput +=  Object.keys(details.dropoff_address.old).map((dkey)=> {
              let keyPart = dkey.replace(/_/g, ' ').toLowerCase();
              let oldVal = details.dropoff_address.old[dkey];
              let newVal = details.dropoff_address.new[dkey];
              if(oldVal == null){
                oldVal = "";
              }
              if(newVal == null){
                newVal = "";
              }
              let html = "<tr><td><b>"+keyPart+"</b></td><td>"+oldVal+"</td><td>"+newVal+"</td></tr>";
              return html;
          });
        }
        if(Joboutput != "" || Vehicleoutput != "" || pickupAddressoutput != "" || dropoffAddressoutput != ""){
          output = Joboutput+Vehicleoutput+pickupAddressoutput+dropoffAddressoutput;
        }else{
          output = "<td colspan='3'>No details found.</td>";
        }
        tbl += '<table class="historyNotification"><thead><th></th><th>Before</th><th>Now</th></thead><tbody>'+output+'</tbody></table>';
        tbl =  tbl.replace(/\,/g,"");
        document.querySelector('#infomodal .modal-body').innerHTML = tbl;
        infoModal.modal();
      }
    render() {
        return (
            <button className="btn btn-default float-right-btn" onClick={(e) => this.handleDiffHistory(e)}><i className="fa fa-clipboard-list"></i> Details</button>
        );
    }
}

